module.exports = __webpack_public_path__ + "img/img-3.bc5add1e.jpg";